import React from 'react'
import PropTypes from 'prop-types'

import style from './style.css'

export default class CursorIndicator extends React.Component {
  
  constructor( props ) {
    super( props )
    this.state = { cursorX : null }
  }
  
  render() {
    const { cursorX } = this.state

    return (
      <div className={style.cursorZone} style={{ left : cursorX, visibility : cursorX == null ? 'hidden' : 'visible' }} /> 
    )
  }

}
